import { Dispatch } from 'redux';
import Service from 'src/setup/network';
import { Inventory } from 'src/types/model';
import {
  FETCH_INVENTORY_FAILURE,
  FETCH_INVENTORY_REQUEST,
  FETCH_INVENTORY_SUCCESS,
  InventoryActionType,
} from '../types/inventoryType';

export const fetchInventoryRequest = (): InventoryActionType => ({
  type: FETCH_INVENTORY_REQUEST,
});

export const fetchInventorySuccess = (
  data: Inventory[]
): InventoryActionType => ({
  type: FETCH_INVENTORY_SUCCESS,
  payload: data,
});

export const fetchInventoryFailure = (error: string): InventoryActionType => ({
  type: FETCH_INVENTORY_FAILURE,
  payload: error,
});

export const fetchInventory = () => {
  return async (dispatch: Dispatch<InventoryActionType>) => {
    dispatch(fetchInventoryRequest());
    try {
      const request = await Service.get('/items/inventory');
      const data: Inventory[] = request?.data;
      dispatch(fetchInventorySuccess(data));
    } catch (error: any) {
      dispatch(fetchInventoryFailure(error?.response?.data?.message));
      throw new Error('Failed to fetch customer');
    }
  };
};
